import {CART_ID_CONDITION_SUFFIX} from "../../util/Constants";
import {getNodeId} from "../../util/Util";

function getBattery(item) {
    const val = parseInt((item.dynamicAttributes || {}).battery, 10);
    return isNaN(val) ? 0 : val;
}

function applyPercentileFilter(data, percentile) {
    if (!percentile || !data || data.length === 0) return data || [];
    const sorted = [...data].sort((a, b) => getBattery(a) - getBattery(b));
    const cutoff = Math.ceil(sorted.length * (percentile / 100));
    return sorted.slice(0, cutoff);
}

function escapeForRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Builds the cart ID condition for the current station, or null when there is no station code to pin against.
// Callers treat null as "no condition applies".
function buildCartIdCondition() {
    const stationCode = getNodeId();
    if (!stationCode) return null;
    return new RegExp('^' + escapeForRegExp(stationCode) + CART_ID_CONDITION_SUFFIX, 'i');
}

// Drops carts whose scannableId is not <stationCode>-CART-<number>. This is a precondition on what
// the dashboard considers a cart at all, not a user-facing filter.
function applyCartIdCondition(data) {
    if (!data || data.length === 0) return data || [];
    const condition = buildCartIdCondition();
    if (!condition) return data;
    return data.filter(item => item && condition.test(item.scannableId || ''));
}

export {applyPercentileFilter, buildCartIdCondition, applyCartIdCondition};



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontrollerstag/CartFilterUtils.js